import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { listarTickets } from '../../utils/api';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = (n) =>
  new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
    .format(Number(n) || 0);
const num = (v) => parseFloat(v) || 0;

export default function Dashboard() {
  const { usuario, puedeVer } = useAuth();
  const esGerencia   = puedeVer('gerencia');
  const esAdmin      = puedeVer('administracion', 'gerencia');
  const esEmpleado   = puedeVer('empleado');
  const hoy          = format(new Date(), 'yyyy-MM-dd');

  // Empleados van directo a marcaciones
  if (esEmpleado) {
    return <Navigate to="/marcaciones" />;
  }

  const [resumen, setResumen]               = useState(null);
  const [sobresResumen, setSobresResumen]   = useState([]);
  const [correcciones, setCorrecciones]     = useState([]);
  const [ticketsUrgentes, setTicketsUrgentes] = useState([]);

  useEffect(() => {
    if (esAdmin) {
      API.get('/caja/consolidado', { params: { fecha: hoy } })
        .then(r => setResumen(r.data)).catch(() => {});
      API.get('/sobres/resumen')
        .then(r => setSobresResumen(r.data)).catch(() => {});
      API.get('/correcciones')
        .then(r => setCorrecciones(r.data)).catch(() => {});
    }
    listarTickets({ prioridad: 'urgente', estado: 'abierto' })
      .then(r => setTicketsUrgentes(r.data.tickets || [])).catch(() => {});
  }, []);

  const fechaFormateada = format(new Date(), "EEEE d 'de' MMMM, yyyy", { locale: es });
  const totalSobresPendientes = sobresResumen.reduce((a, b) => a + parseInt(b.pendientes || 0), 0);
  const totalValorPendiente   = sobresResumen.reduce((a, b) => a + num(b.valor_pendiente), 0);

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 960, margin: '0 auto' }}>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>¡Hola, {usuario?.nombre?.split(' ')[0]}! 👋</h1>
          <p style={s.fecha}>{fechaFormateada}</p>
        </div>
        <div style={s.areaBadge}>{usuario?.area_nombre || usuario?.rol}</div>
      </div>

      {ticketsUrgentes.length > 0 && (
        <div style={s.alertBox}>
          <span style={{ fontSize: 24 }}>🚨</span>
          <div>
            <strong>{ticketsUrgentes.length} novedad(es) urgente(s)</strong>
            <p style={{ margin: '2px 0 0', fontSize: 13, color: '#ef4444' }}>Requieren atención inmediata</p>
          </div>
          <Link to="/tickets?prioridad=urgente" style={s.alertBtn}>Ver ahora</Link>
        </div>
      )}

      <div style={s.grid}>
        <ModuleCard icon="🍦" title="Inventario Helados" desc="Registrar bandejas y distribución" href="/helados" color="#f59e0b" />
        {puedeVer('gerencia', 'administracion', 'punto_venta') && (
          <ModuleCard icon="📦" title="Inventario General" desc="Vasos, conos, insumos" href="/inventario" color="#3b82f6" />
        )}
        {puedeVer('gerencia', 'administracion', 'produccion') && (
          <ModuleCard icon="🚚" title="Envíos de Helado" desc="Distribución a puntos de venta" href="/envios-helado" color="#f97316" />
        )}
        {puedeVer('gerencia', 'administracion', 'produccion') && (
          <ModuleCard icon="🛍️" title="Envíos de Productos" desc="Insumos y productos generales" href="/envios-general" color="#06b6d4" />
        )}
        {puedeVer('gerencia', 'administracion', 'produccion') && (
          <ModuleCard icon="🏭" title="Inventario Producción" desc="Materias primas e insumos" href="/produccion" color="#7c3aed" />
        )}
        {puedeVer('gerencia', 'administracion', 'punto_venta') && (
          <ModuleCard icon="💰" title="Control de Caja" desc="Cierre diario de ventas" href="/caja" color="#10b981" />
        )}
        {puedeVer('gerencia', 'administracion', 'punto_venta') && (
          <ModuleCard icon="💵" title="Sobres" desc="Trazabilidad del efectivo" href="/sobres" color="#f59e0b" />
        )}
        {puedeVer('gerencia', 'administracion') && (
          <ModuleCard icon="📈" title="Ventas Unificadas" desc="Aliaddo + POS todos los PDVs" href="/ventas-unificadas" color="#0369a1" />
        )}
        {puedeVer('gerencia', 'administracion') && (
          <ModuleCard icon="📦" title="Materia Prima" desc="Recepción, stock y consumo" href="/materia-prima" color="#7c3aed" />
        )}
        {puedeVer('gerencia', 'administracion', 'produccion') && (
          <ModuleCard icon="🍦" title="Producción Helados" desc="Órdenes, mixes, recetas y bandejas" href="/produccion-helados" color="#0891b2" />
        )}
        {puedeVer('gerencia', 'administracion') && (
          <ModuleCard icon="⚖️" title="Cuadre de Inventario" desc="Control diario y semanal" href="/cuadre" color="#0f766e" />
        )}
        <ModuleCard icon="🔧" title="Novedades" desc="Mantenimiento y PQRS" href="/tickets" color="#ef4444" />
        <ModuleCard icon="💬" title="Chat" desc="Comunicación interna" href="/chat" color="#8b5cf6" />
      </div>

      {esAdmin && resumen?.puntos && (
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <h2 style={s.sectionTitle}>💰 Cierres de Caja — Hoy</h2>
            <Link to="/caja" style={s.verTodo}>Ver detalle →</Link>
          </div>
          <div style={s.cajaGrid}>
            {resumen.puntos.map((p) => {
              const dif = num(p.diferencia);
              const cuadra = Math.abs(dif) < 100;
              return (
                <div key={p.bodega} style={{ ...s.cajaCard, borderTop: `3px solid ${p.estado ? '#10b981' : '#E5E7EB'}` }}>
                  <div style={s.cajaNombre}>🏪 {p.bodega}</div>
                  {p.estado ? (
                    <>
                      <div style={{ ...s.cajaEstado, ...estadoColor(p.estado) }}>{p.estado}</div>
                      <div style={{ fontSize: 13, color: '#374151', marginTop: 6, display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <div>💵 <strong>{COP(p.total_efectivo)}</strong></div>
                        <div>🏦 <strong>{COP(p.total_banco)}</strong></div>
                        {num(p.total_rappi) > 0 && <div>🛵 <strong>{COP(p.total_rappi)}</strong></div>}
                      </div>
                      <div style={{ marginTop: 6, fontSize: 12, fontWeight: 700, color: cuadra ? '#10b981' : dif < 0 ? '#ef4444' : '#f59e0b' }}>
                        {cuadra ? '✅ Cuadra' : dif < 0 ? `❌ Faltante ${COP(dif)}` : `⚠️ Sobrante +${COP(dif)}`}
                      </div>
                    </>
                  ) : (
                    <div style={{ color: '#9ca3af', fontSize: 13, marginTop: 8 }}>⏳ Sin cierre</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {esAdmin && sobresResumen.length > 0 && (
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <h2 style={s.sectionTitle}>💵 Sobres Pendientes</h2>
            <Link to="/sobres" style={s.verTodo}>Ver todos →</Link>
          </div>
          {totalSobresPendientes === 0 ? (
            <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 12, padding: '14px 18px', color: '#065F46', fontWeight: 600, fontSize: 14 }}>
              ✅ Todos los sobres están registrados
            </div>
          ) : (
            <>
              <div style={s.cajaGrid}>
                {sobresResumen.map((b) => {
                  const pendientes = parseInt(b.pendientes || 0);
                  return (
                    <div key={b.bodega_id} style={{ ...s.cajaCard, borderTop: `3px solid ${pendientes > 0 ? '#F59E0B' : '#10b981'}` }}>
                      <div style={s.cajaNombre}>🏪 {b.bodega}</div>
                      {pendientes > 0 ? (
                        <>
                          <div style={{ ...s.cajaEstado, background: '#FEF3C7', color: '#92400E' }}>
                            ⚠️ {pendientes} pendiente{pendientes > 1 ? 's' : ''}
                          </div>
                          {esGerencia && (
                            <div style={{ fontSize: 13, color: '#374151', marginTop: 6, fontWeight: 700 }}>
                              {COP(b.valor_pendiente)}
                            </div>
                          )}
                        </>
                      ) : (
                        <div style={{ ...s.cajaEstado, background: '#D1FAE5', color: '#065F46' }}>✅ Al día</div>
                      )}
                    </div>
                  );
                })}
              </div>
              {esGerencia && (
                <div style={{ marginTop: 12, background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 10, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 700, color: '#92400E' }}>💰 Total efectivo pendiente:</span>
                  <span style={{ fontWeight: 800, fontSize: 18, color: '#92400E', fontFamily: 'monospace' }}>{COP(totalValorPendiente)}</span>
                </div>
              )}
            </>
          )}
        </div>
      )}
      {esAdmin && correcciones.filter(c => c.estado === 'pendiente').length > 0 && (
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <h2 style={s.sectionTitle}>✏️ Solicitudes de Corrección</h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {correcciones.filter(c => c.estado === 'pendiente').map((c, i) => (
              <CorreccionCard key={i} correccion={c} onActualizar={() => API.get('/correcciones').then(r => setCorrecciones(r.data))} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function CorreccionCard({ correccion: c, onActualizar }) {
  const [actuando, setActuando] = useState(false);

  const handleAccion = async (accion) => {
    setActuando(true);
    try {
      await API.patch(`/correcciones/${c.id}`, { estado: accion });
      toast.success(accion === 'aprobada' ? 'Corrección aprobada — registro desbloqueado' : 'Solicitud rechazada');
      onActualizar();
    } catch { toast.error('Error al procesar solicitud'); }
    finally { setActuando(false); }
  };

  return (
    <div style={{ background: 'white', borderRadius: 12, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: '4px solid #F59E0B', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 700, fontSize: 14 }}>
            {c.tipo === 'cierre_caja' ? '💰 Cierre de Caja' : '🍦 Inventario Helados'}
          </span>
          <span style={{ fontSize: 12, color: '#6B7280' }}>— {c.bodega_nombre || `Bodega ${c.bodega_id}`}</span>
          <span style={{ fontSize: 11, color: '#9CA3AF' }}>{c.fecha_cierre || ''}</span>
        </div>
        <div style={{ fontSize: 13, color: '#374151', marginBottom: 4 }}>
          <strong>Solicitado por:</strong> {c.solicitado_nombre || 'Usuario'}
        </div>
        <div style={{ fontSize: 13, color: '#374151', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginTop: 6 }}>
          "{c.motivo}"
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={() => handleAccion('rechazada')}
          disabled={actuando}
          style={{ padding: '8px 14px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#6B7280' }}
        >
          ✕ Rechazar
        </button>
        <button
          onClick={() => handleAccion('aprobada')}
          disabled={actuando}
          style={{ padding: '8px 14px', border: 'none', borderRadius: 8, background: 'linear-gradient(135deg,#059669,#047857)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}
        >
          ✓ Aprobar
        </button>
      </div>
    </div>
  );
}

function ModuleCard({ icon, title, desc, href, color }) {
  return (
    <Link to={href} style={{ textDecoration: 'none' }}>
      <div style={s.moduleCard}>
        <div style={{ ...s.moduleIcon, background: color + '20', color }}>{icon}</div>
        <div>
          <div style={s.moduleTitle}>{title}</div>
          <div style={s.moduleDesc}>{desc}</div>
        </div>
        <span style={{ marginLeft: 'auto', color: '#9ca3af', fontSize: 18 }}>→</span>
      </div>
    </Link>
  );
}

function estadoColor(estado) {
  return ({
    aprobado:    { background: '#d1fae5', color: '#065f46' },
    enviado:     { background: '#dbeafe', color: '#1e40af' },
    con_novedad: { background: '#fee2e2', color: '#991b1b' },
    borrador:    { background: '#f3f4f6', color: '#6b7280' },
    revisado:    { background: '#fef3c7', color: '#92400e' },
  }[estado] || { background: '#f3f4f6', color: '#6b7280' });
}

const s = {
  header:      { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
  title:       { margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' },
  fecha:       { color: '#6b7280', margin: '4px 0 0', fontSize: 14, textTransform: 'capitalize' },
  areaBadge:   { background: '#1a1a2e', color: 'white', padding: '8px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600 },
  alertBox:    { display: 'flex', alignItems: 'center', gap: 16, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '16px 20px', marginBottom: 24 },
  alertBtn:    { marginLeft: 'auto', background: '#ef4444', color: 'white', padding: '8px 16px', borderRadius: 8, textDecoration: 'none', fontSize: 13, fontWeight: 600 },
  grid:        { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16, marginBottom: 32 },
  moduleCard:  { background: 'white', borderRadius: 12, padding: 20, display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', cursor: 'pointer' },
  moduleIcon:  { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, flexShrink: 0 },
  moduleTitle: { fontWeight: 700, color: '#111827', fontSize: 15 },
  moduleDesc:  { color: '#6b7280', fontSize: 13, marginTop: 2 },
  section:     { marginBottom: 32 },
  sectionHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  sectionTitle:  { fontSize: 18, fontWeight: 800, color: '#111827', margin: 0 },
  verTodo:     { fontSize: 13, color: '#6366F1', textDecoration: 'none', fontWeight: 600 },
  cajaGrid:    { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 },
  cajaCard:    { background: 'white', borderRadius: 10, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  cajaNombre:  { fontWeight: 700, fontSize: 14, marginBottom: 8, color: '#111827' },
  cajaEstado:  { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 },
};
